export default __webpack_public_path__ + "static/media/cropsImage.38906ccc.png";